import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import {
  staggerReveal,
  fadeInUp,
  staggerText,
  handleHover,
  handleHoverExit,
} from "./MenuAnimations";

export default function Menu({ state }) {
  //useRef = gaining accesss to animated DOM elements:
  let menu = useRef(null);
  let revealMenu = useRef(null);
  let revealMenuBackground = useRef(null);
  let line1 = useRef(null);
  let line2 = useRef(null);
  let line3 = useRef(null);
  let info = useRef(null);

  // useEffect to be able to toggle the menu back and forth:
  useEffect(() => {
    if (state.clicked === false) {
      // CLOSE MENU:
      gsap.to([revealMenu, revealMenuBackground], {
        duration: 0.8,
        height: 0,
        ease: "power3.inOut",
        // without stagger you cannot see revealMenuBackground - (black one)
        stagger: {
          // here amount means delay:
          amount: 0.07,
        },
      });
      //menu is a parent element of revealMenu & revealMenuBackground, duration here has to be longer than children menu
      gsap.to(menu, {
        duration: 1,
        css: {
          display: "none",
        },
      });
    }

    // OPEN THE MENU:.
    else if (state.clicked === true || state.initial === null) {
      //open the menu:
      gsap.to(menu, {
        duration: 0,
        css: {
          display: "block",
        },
      });
      //Allow menu to have the height of 100%:
      gsap.to([revealMenuBackground, revealMenu], {
        duration: 0,
        opacity: 1,
        height: "100%",
      });
      staggerReveal(revealMenuBackground, revealMenu);
      fadeInUp(info);
      staggerText(line1, line2, line3);
    }
  }, [state]); // use dependency [state] to watch changes

  return (
    <div ref={(el) => (menu = el)} className="hamburger-menu">
      <div
        ref={(el) => (revealMenuBackground = el)}
        className="menu-secondary-background-color"
      ></div>
      <div ref={(el) => (revealMenu = el)} className="menu-layer">
        <div className="container">
          <div className="wrapper">
            <div className="menu-links">
              <nav>
                <ul>
                  <li>
                    <Link
                      onMouseEnter={(e) => handleHover(e)}
                      onMouseOut={(e) => handleHoverExit(e)}
                      ref={(el) => (line1 = el)}
                      to="./about"
                    >
                      About
                    </Link>
                  </li>
                  <li>
                    <Link
                      onMouseEnter={(e) => handleHover(e)}
                      onMouseOut={(e) => handleHoverExit(e)}
                      ref={(el) => (line2 = el)}
                      to="./projects"
                    >
                      Projects
                    </Link>
                  </li>
                  <li>
                    <Link
                      onMouseEnter={(e) => handleHover(e)}
                      onMouseOut={(e) => handleHoverExit(e)}
                      ref={(el) => (line3 = el)}
                      to="./contact"
                    >
                      Contact
                    </Link>
                  </li>
                </ul>
              </nav>
              <div ref={(el) => (info = el)} className="info">
                <h3>what I do:</h3>
                <p>
                  workout, <span className="black">WebDev</span>, reading,
                  sleeping, listening to music
                </p>
              </div>

              <div className="social-media-icons">
                <a
                  href="https://github.com/IshaanTyagi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-github"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/ishaan-tyagi-998228146/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
                <a
                  href="https://www.instagram.com/its_ishaan._/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
